<div class="flex flex-column h-full" *ngIf="user!=null">
    <div *ngIf="case!=null" class="chat-header flex flex-column gap-2">
        <div><b>Expediente:</b> {{case?.caseNumber}}</div>
        <div><b>Asegurado:</b> {{case?.client?.name}}</div>
        <div><b>Dirección:</b> {{case?.client?.address?.fullAddress}}</div>
    </div>
    <div class="session-window" *ngIf="isSessionOpen" [class.ending-soon]="sessionEndingSoon">
        <i class="pi" [class.pi-clock]="!sessionEndingSoon" [class.pi-exclamation-triangle]="sessionEndingSoon"></i>
        <span>Ventana abierta &middot; quedan {{sessionRemaining}}</span>
    </div>
    <div #chatMessages class="chat-messages flex-grow-1">
        <div *ngFor="let message of messages" [class.chat-message-left]="message.direction=='Inbound'" [class.chat-message-right]="message.direction=='Outbound'">
            <div class="chat-message">
                <div class="message-info">
                    <span class="user-name" *ngIf="message.direction=='Inbound'">{{case?.client?.name}}</span>
                    <span class="user-name" *ngIf="message.direction=='Outbound'">{{message.createdByUser?.name}}</span>
                </div>
                <div class="message" [innerHTML]="message.content"></div>
                <div class="message-info mt-1">
                    <span class="date">{{message.createdAt | date:'dd/MM/yyyy HH:mm:ss'}}</span>
                    <span class="state-icon pi"
                        pTooltip="{{message.stateInfo}}" tooltipPosition="top"
                        [class.pi-check]="message.state=='Sent' || message.state=='Received'" [class.text-success]="message.state=='Sent' || message.state=='Received'"
                        [class.pi-times-circle]="message.state=='Error'" [class.text-danger]="message.state=='Error'"
                        [class.pi-clock]="message.state=='Pending' || message.state=='Sending'" [class.text-warning]="message.state=='Pending' || message.state=='Sending'"
                    ></span>
                </div>
            </div>
        </div>
        <div *ngIf="messages.length==0">
            Todavía no hay mensajes
        </div>
    </div>
    <div *ngIf="!isSessionOpen" class="mt-4">
        <p-messages severity="warn" [closable]="false" >
            <ng-template pTemplate>
                <div>
                    <b>La ventana de 24 horas está cerrada.</b><br>
                    Fuera de la ventana, WhatsApp solo permite enviar plantillas aprobadas por el administrador.<br>
                    La ventana se abrirá <b>cuando el cliente responda</b>, y a partir de ese momento podrás
                    escribirle mensajes libres durante 24 horas.
                </div>
            </ng-template>
        </p-messages>
        <p-button (click)="openTemplateDialog()" icon="pi pi-send" label="Enviar plantilla" />
    </div>
    <div class="mt-2 flex gap-2 align-items-end" *ngIf="isSessionOpen">
        <textarea pInputTextarea [autoResize]="true" rows="1" placeholder="Escribe tu mensaje" [(ngModel)]="message" class="flex-grow-1 chat-message-input"
            [style.max-height.px]="150"
            [readonly]="template_id!=''" [pTooltip]="template_id!='' ? 'Plantilla seleccionada: el texto no se puede editar o dejaría de coincidir con la aprobada' : ''"
            (keydown)="onEnter($event)"></textarea>
        <p-button *ngIf="template_id!=''" (click)="clearMessageTemplate()" icon="pi pi-times" styleClass="p-button-secondary" pTooltip="Quitar la plantilla y escribir libremente" tooltipPosition="top" />
        <p-button (click)="templateSearch=''; op.toggle($event)" icon="pi pi-sparkles" styleClass="p-button-secondary" pTooltip="Seleccionar plantilla" tooltipPosition="top" />
        <p-button (click)="sendMessage()" icon="pi pi-send" />
    </div>

    <p-overlayPanel #op appendTo="body" [style]="{ width: '350px' }">
        <ng-template pTemplate="content">
            <div class="input-field" style="position: relative; margin-bottom: 10px;">
                <input type="text" pInputText placeholder="Texto a buscar..." [(ngModel)]="templateSearch" />
                <i class="pi pi-search" style="position: absolute; right: 10px; top: 10px;"></i>
            </div>
            <div *ngFor="let template of getFilteredTemplates(); index as i" class="template">
                <div class="flex align-items-center gap-2">
                    <div class="flex flex-column flex-grow-1">
                        <span>{{template.name}}</span>
                        <small style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden; width: 250px;">{{template.content}}</small>
                    </div>
                    <button pButton icon="pi pi-chevron-right" (click)="selectMessageTemplate(template); op.hide()" size="small"></button>
                </div>
            </div>
            <div *ngIf="getFilteredTemplates().length === 0">No se encontraron plantillas de Whatsapp</div>
        </ng-template>
    </p-overlayPanel>
</div>

<p-dialog header="Enviar plantilla" [(visible)]="displayTemplateDialog" [modal]="true" [closable]="false" [style]="{width: '400px'}">
    <div class="flex flex-column gap-4">
        <div class="input-field">
            <p-dropdown placeholder="Selecciona plantilla" [options]="templates" [(ngModel)]="template_id" optionLabel="name" optionValue="id"  appendTo="body" (onChange)="changeTemplate($event)"></p-dropdown>
        </div>
        <div class="input-field">
            <textarea pInputTextarea [(ngModel)]="message" rows="5" [readonly]="true"></textarea>
        </div>
        <div class="flex justify-content-between gap-2">
            <p-button label="Cancelar" (click)="displayTemplateDialog=false" />
            <p-button label="Enviar" (click)="confirmTemplateDialog()" />
        </div>
    </div>
</p-dialog>